import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

/**
 * PageSkeleton - Generic page skeleton for Suspense fallback
 * Provides a simple skeleton layout that works for any page
 */
const PageSkeleton = () => {
	return (
		<div style={{ padding: '2rem' }}>
			{/* Hero section skeleton */}
			<section
				style={{
					padding: '3rem 2rem',
					textAlign: 'center',
					background: '#f5f5f5',
					marginBottom: '3rem',
					borderRadius: '8px',
				}}
			>
				<Skeleton height={48} width="60%" style={{ margin: '0 auto 1rem' }} />
				<Skeleton height={28} width="40%" style={{ margin: '0 auto 1rem' }} />
				<Skeleton height={20} width="70%" style={{ margin: '0 auto 2rem' }} />
				<Skeleton height={44} width={180} style={{ margin: '0 auto' }} />
			</section>

			{/* Content area skeleton */}
			<section style={{ maxWidth: '1200px', margin: '0 auto' }}>
				<Skeleton height={36} width="30%" style={{ marginBottom: '2rem' }} />
				<Skeleton height={20} width="80%" style={{ marginBottom: '1rem' }} />
				<Skeleton height={20} width="75%" style={{ marginBottom: '1rem' }} />
				<Skeleton height={20} width="85%" style={{ marginBottom: '2rem' }} />
				<div
					style={{
						display: 'grid',
						gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
						gap: '1.5rem',
						marginTop: '2rem',
					}}
				>
					{Array.from({ length: 6 }).map((_, i) => (
						<div key={i} style={{ padding: '1.5rem', background: 'white', borderRadius: '8px' }}>
							<Skeleton height={200} style={{ marginBottom: '1rem', borderRadius: '8px' }} />
							<Skeleton height={24} width="70%" style={{ marginBottom: '0.5rem' }} />
							<Skeleton height={16} count={2} />
						</div>
					))}
				</div>
			</section>
		</div>
	);
};

export default PageSkeleton;
